import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { Col, Row } from 'react-bootstrap';
import Enums from '../../enums';
import Loading from '../Loading';

class ProjectsApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor() {
        super();
        Tools.init();
        API.init(this);

        this.state = {
            ty: this.E_TYPE.ALL,
            list: [],
            hideIndexList: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                true,
            ],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "編號",
                "來源",
                "名稱",
                "點數",
                "上架時間",
                "下架時間",
                // "預定填答人數",
                "填答人數",
                "完成人數",
                ""
            ],
            isLoading: false
        };
        this.getData = this.getData.bind(this);
        this.onListViewClicked = this.onListViewClicked.bind(this);
        //using set timeout to make setState working
        setTimeout(() => this.getData(), 0);
    }

    getData() {
        this.setState({ isLoading: true });
        var tmpData = {
            ty: this.state.ty
        };
        API.GetProjects(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index) {
        console.log(index, this.props.history);
        // alert("沒有datail介面ppt (其實連這頁list也沒資料,但有api就順手做了)");
        this.props.history.push("/proj/edit/" + index);
        // window.open(this.props.history.createHref({
        //     pathname: "/proj/edit/" + index
        // }));

        // window.open(this.props.history.createHref("/proj/add?pid=" + index));
    }

    onDataUpdated(data) {
        this.setState({ isLoading: false });
        // console.log(this);
        if (data && data.data) {
            // console.log(data);
            const tmp = [];
            for (let index in data.data) {
                const tmpObj = data.data[index];
                // "專案編號",
                // "專案名稱",
                // "點數",
                // "上架時間",
                // "下架時間",
                // "預定填答人數",
                // "填答人數",
                // "完成度"
                tmp.push({
                    key: tmpObj.pid,
                    data: [
                        tmpObj.pid,
                        tmpObj.source,
                        tmpObj.name,
                        tmpObj.point,
                        Tools.getFormatDate(tmpObj.start_at),
                        Tools.getFormatDate(tmpObj.end_at),
                        // tmpObj.max_people,
                        tmpObj.max_people,
                        tmpObj.complete_people,
                        tmpObj.updated_at
                    ]
                });
            }
            this.setState({
                list: tmp,
                sort_type: [
                    Enums.ESORT.STR,
                    Enums.ESORT.STR,
                    Enums.ESORT.STR,
                    Enums.ESORT.NUM,
                    Enums.ESORT.DATETIME,
                    Enums.ESORT.DATETIME,
                    Enums.ESORT.NUM,
                    Enums.ESORT.NONE,
                    Enums.ESORT.NUM,
                ]
            })
        }
    }

    render() {
        const { list, sort_type, fields, hideIndexList, isLoading } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list}
                    sort_type={sort_type}
                    fields={fields}
                    title={"專案列表"}
                    onRowClicked={onListViewClicked}
                    sort_index={8}
                    ascending={false}
                    fileName={"GetProjectsSummaryCSV"}
                    hideIndexList={hideIndexList}
                />
                <Loading isLoading={isLoading} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(ProjectsApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsApp))